// extracted by mini-css-extract-plugin
module.exports = {"root":"DepositFormText_root__lDbut","header":"DepositFormText_header__V2jdL","content":"DepositFormText_content__Je8FQ","field":"DepositFormText_field__MxjvF"};